import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoRefreshService {
  
  // Subject para notificar cuando se debe refrescar los datos
  private refreshSubject = new Subject<void>();
  
  // Observable que los componentes pueden suscribirse
  public refresh$ = this.refreshSubject.asObservable();
  
  constructor() { }
  
  /**
   * Emite el evento de refresh para notificar a todos los componentes suscritos
   */
  emitRefresh(): void {
    this.refreshSubject.next();
  }
}
